import { useGLTF } from '@react-three/drei';
import { PrimitiveProps } from '@react-three/fiber';
import * as React from 'react';

export type Props = Omit<PrimitiveProps, 'object'> & {
  url: string;
};

function Model(props: Props) {
  const { url, ...rest } = props;
  const deferred = React.useDeferredValue(url);
  const { scene, ...restGltf } = useGLTF(deferred);
  console.log('Model', { restGltf });
  return <primitive object={scene} {...rest} />;
}

export default React.memo(Model);
